export * from './run';
export * from './season';
export * from './energy';
import type { PerkId } from './run';

/**
 * Wire version of the HTTP API contract. Both server and client check this
 * to surface client/server skew explicitly rather than letting silent shape
 * drift cause runtime mysteries.
 *
 * Bump procedure:
 *   1. Make the breaking change.
 *   2. Bump `API_VERSION` here.
 *   3. Update the response-header middleware and ApiClient.req version check.
 *   4. Document migration path in CHANGELOG.
 *
 * Header name: `X-Api-Version`. Sent on every JSON response from the server,
 * validated on every parsed response on the client.
 */
export const API_VERSION = 1;
export const API_VERSION_HEADER = 'X-Api-Version';

export type Player = {
  id: string;
  tgUserId: number;
  tgUsername: string | null;
  tgFirstName: string | null;
  tgLanguageCode: string | null;
  createdAt: number;
  lastSeenAt: number;
  loadoutPerkId?: PerkId | null;
};

export type AuthRequest = {
  initData: string;
};

export type AuthResponse = {
  token: string;
  expiresAt: number;
  player: Player;
};

export type MeResponse = {
  player: Player;
};

export type ApiError = {
  error: string;
  code: string;
};

export type { SectorId, SectorTier, SectorMod, SectorZoneId, SectorDef, SectorZone } from './sectors';
export { SECTORS, SECTOR_ZONES, tierColor } from './sectors';
